module.exports = __webpack_public_path__ + "static/shopee-logo-ca5d12864c12916c05640b36e47ac5c9.png";